import { AssistantMessageRecordDto, useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId, useLanguageCode } from '@mews-commander/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { getCurrentEnterpriseServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';

export const useAssistantMessageReplyQuery = (
    summary: string | undefined,
    messageHistory: AssistantMessageRecordDto[]
) => {
    const languageCode = useLanguageCode();
    const enterpriseId = useCurrentEnterpriseId();
    const serviceId = useCommanderSelector<string>(getCurrentEnterpriseServiceId);

    return useRepositoryQuery(
        'assistantMessageReply',
        'message',
        {
            language: languageCode,
            enterpriseId,
            serviceId,
            summary,
            messageHistory,
        },
        { enabled: !!summary }
    );
};
